import Vue from 'vue';
import VueBootstrap from 'bootstrap-vue';
import VueAxios from 'vue-axios';
import VueMoment from 'vue-moment';
import VueSocketIO from 'vue-socket.io';
import axios from 'axios';
import numFormat from 'vue-filter-number-format';

import App from './App.vue';
import store from './store';
import routes from './routes';
import token from './libs/boogr-token';


require("dotenv").config();
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
    load: { key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY }
});

Vue.filter('numFormat', numFormat);

Vue.use(VueBootstrap);
Vue.use(VueMoment);
Vue.use(VueAxios, axios);

Vue.use(new VueSocketIO({
    debug: false,
    connection: process.env.VUE_APP_BASE_SOCKET,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
    },
    options: { path: '/socket.io'}
}));

axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
axios.defaults.headers['Content-type'] = 'application/json';

global.Vue = Vue;

(async () => {
    token.validate();
    const router = await routes.instance();
    return new Vue({
        sockets: {
            connect: function (socket) {
                // console.log('socket connected')
            },
            customEmit: function (data) {
                // console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
            }
        },
        router,
        store,
        render: h => h(App),
        created: function () {
            token.refresh(1000 * 60 * 30);
            window.router = router;
        }
    }).$mount('#app');
})();

window._store = store;
